module.exports = __webpack_public_path__ + "static/media/ordering_img.9de48c61.svg";